// ZIDXAccountFormFieldEdit.ts
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountFormFieldEdit implements ZIDXPage {
    zidx: ZIDX;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountFormFieldEditContainer";
    }

    // Fields that are shown for each type. Anything not listed = hidden.
    static readonly FIELD_VISIBILITY: Record<string, string[]> = {
        HIDDEN:   ["form_field_name", "form_field_default_value"],
        SUBMIT:   ["form_field_name", "form_field_label"],
        SEPARATOR:["form_field_name", "form_field_label", "form_field_help_text"],
        HTML:     ["form_field_name", "form_field_label"],
        BOOLEAN:  ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_options", "form_field_help_text", "form_field_default_value"],
        RADIO:    ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_options", "form_field_help_text", "form_field_default_value"],
        CHECKBOX: ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_options", "form_field_help_text", "form_field_default_value"],
        SELECT:   ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_options", "form_field_help_text", "form_field_default_value"],
        TEXT:     ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value"],
        EMAIL:    ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value"],
        URL:      ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value"],
        COLOR:    ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value"],
        TEXTAREA: ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value"],
        NUMBER:   ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_placeholder", "form_field_help_text", "form_field_default_value", "form_field_min_value", "form_field_max_value"],
        DATE:     ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_help_text", "form_field_default_value", "form_field_min_value", "form_field_max_value"],
        DATETIME: ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_help_text", "form_field_default_value", "form_field_min_value", "form_field_max_value"],
        FILE:     ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_help_text"],
        IMAGE:    ["form_field_name", "form_field_label", "form_field_required", "form_field_active", "form_field_help_text"],
    };

    // All possible field names that can be shown/hidden
    static readonly ALL_FIELDS: string[] = [
        "form_field_name",
        "form_field_label",
        "form_field_type",      // always visible
        "form_field_options",
        "form_field_placeholder",
        "form_field_help_text",
        "form_field_default_value",
        "form_field_min_length",
        "form_field_max_length",
        "form_field_min_value",
        "form_field_max_value",
        "form_field_sort_order",
        "form_field_required",
        "form_field_active",
    ];

    render() {
        const root = this.zidx.peakidxShadowRoot;
        const typeSelect = root.querySelector<HTMLSelectElement>(
            ".zidxAccountFormFieldEditContainer select[name='form_field_type']"
        );
        if (!typeSelect) {
            return; // builtin edit page — no type select rendered
        }

        const applyVisibility = (type: string) => {
            const visible = new Set(ZIDXAccountFormFieldEdit.FIELD_VISIBILITY[type] ?? []);
            for (const fieldName of ZIDXAccountFormFieldEdit.ALL_FIELDS) {
                if (fieldName === "form_field_type") continue; // always shown
                // Each form field is wrapped in a container with name attribute
                const wrapper = root.querySelector<HTMLElement>(
                    `.zidxAccountFormFieldEditContainer #${fieldName}_container`
                );
                if (!wrapper) continue;
                wrapper.style.display = visible.has(fieldName) ? "" : "none";
            }
        };

        // Apply on load
        applyVisibility(typeSelect.value);

        // Apply on change
        typeSelect.addEventListener("change", () => {
            applyVisibility(typeSelect.value);
        });
    }
}